import {createFileRoute} from '@tanstack/react-router';
import {AuthSignUpPage} from '@/features/auth';
import {authSignedGuard, can} from '@/libs/router';

interface SignUpSearchParams {
  error?: string;
  provider?: string;
}

export const Route = createFileRoute('/_auth/auth/signup')({
  beforeLoad: can([authSignedGuard]),
  validateSearch: (search: SignUpSearchParams) => search,
  component: () => <AuthSignUpPage />,
});
